// The decisions of the combobox controller (controllers/combobox_controller.js)
// as pure functions, so they are tested without a browser
// (test/javascript/combobox_logic.test.js, `yarn test`).

// What a key does in the combobox's text field, or null to let the browser
// have it (Enter on an empty field submits the form, Tab moves on).
//   state: { open, active, query, chips }
export function keyAction(key, { open, active, query, chips }) {
  const typed = query.trim() !== ""
  switch (key) {
    case "ArrowDown": return open ? "next" : "open"
    case "ArrowUp": return open ? "prev" : "open"
    case "Enter": return typed || (open && active >= 0) ? "choose" : null
    case "Escape":
      if (open) return "close"
      return typed ? "clear" : null
    case "Backspace": return query === "" && chips > 0 ? "removeLast" : null
    case "Tab": return open ? "dismiss" : null
    default: return null
  }
}

// The next active option, wrapping around; -1 when there is none.
export function moveIndex(index, delta, length) {
  if (length <= 0) return -1
  if (index < 0) return delta > 0 ? 0 : length - 1
  return (index + delta + length) % length
}

// The suggestions not chosen yet.
export function remaining(options, chosen) {
  const taken = new Set(chosen)
  return options.filter((option) => !taken.has(option.value))
}

// What Enter picks: the active option; else the one whose value is what was
// typed ("62.10" is "6210", case ignored); else the typed text itself where
// any value goes (free); else the only suggestion; else nothing.
export function resolveChoice({ query, options, active, free }) {
  if (active >= 0 && options[active]) return options[active]
  const text = query.trim()
  if (text === "") return null

  const code = text.replace(/[.\s]/g, "").toLowerCase()
  const exact = options.find((option) => option.value.toLowerCase() === code)
  if (exact) return exact
  if (free) return { value: text, label: text }
  return options.length === 1 ? options[0] : null
}

// "/suggest/nace?q=softv%C3%A9r"
export function suggestUrl(base, query) {
  const separator = base.includes("?") ? "&" : "?"
  return `${base}${separator}q=${encodeURIComponent(query.trim())}`
}

// "Žiadne návrhy", "1 návrh", "3 návrhy", "10 návrhov": what the live region says.
export function countMessage(count) {
  if (count === 0) return "Žiadne návrhy"
  if (count === 1) return "1 návrh"
  if (count >= 2 && count <= 4) return `${count} návrhy`
  return `${count} návrhov`
}
